export default "__VITE_ASSET__1p23bEZ0__"